




























































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {WhiteListItem} from "@/store/settings/white_list/types";
import ImportWhiteList from "@/components/Settings/WhiteLists/ImportWhiteList.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import WhiteListFilter from "@/components/Settings/WhiteLists/WhiteListFilter.vue";

@Component({components: {WhiteListFilter, ImportWhiteList, ScrollButton}})
export default class WhiteLists extends BaseItemsPage<WhiteListItem> {
  @Getter("whiteLists") whiteLists: any;
  @Action("deleteWhiteLists") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private is_show_import = false;
  private is_show_filter = false;
  private recipientIds: (number | undefined)[] = [];
  private logObject: ActionLog = {};
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['msisdn', 'email', 'description',];

  getData(): any {
    return this.whiteLists;
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams({id: this.$route.params.id, number: this.recipientIds.length})
        }
        const item = {
          id: this.recipientIds,
          recipientIds: this.recipientIds
        }
        await this.actionDelete(item);
        await this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    }
  }

  onSelect(items: WhiteListItem[]): void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }
}
